import { computed, ref } from 'vue'
import { required, email, maxLength, helpers } from '@vuelidate/validators'
import { useVuelidate } from '@vuelidate/core'
import pickBy from 'lodash/pickBy'
import type { UrlParamsDonorDetails, DonorDetails } from '@/types'

export const validator = (formState: any) => {
  const nameFormatValidator = helpers.withMessage(
    'Incorrect format.',
    (value: string) => /^[ \p{L}'-]*$/u.test(value)
  )

  const requiredValidator = helpers.withMessage(
    'This field is required.',
    required
  )

  const agreementValidator = helpers.withMessage(
    'You must agree to our terms and conditions.',
    (value: boolean) => value === true
  )

  const emailValidator = helpers.withMessage(
    'A valid email is required.',
    email
  )

  const maxLengthValidator = (max: number) => {
    return helpers.withParams(
      { type: 'maxLength', value: max },
      helpers.withMessage(
        `The maximum length allowed is ${max} characters.`,
        maxLength(max)
      )
    )
  }

  const rules = computed(() => {
    return {
      emailAddress: { requiredValidator, emailValidator },
      firstname: {
        requiredValidator,
        maxLength: maxLengthValidator(200),
        nameFormatValidator,
      },
      lastname: {
        requiredValidator,
        maxLength: maxLength(200),
        nameFormatValidator,
      },
      postcode: {
        requiredValidator,
        maxLength: maxLengthValidator(10),
      },
      addressLine1: { requiredValidator, maxLength: maxLength(100) },
      addressLine2: { maxLength: maxLengthValidator(100) },
      city: { maxLength: maxLengthValidator(180) },
      county: { maxLength: maxLengthValidator(100) },
      country: { requiredValidator },
      agree: { agreementValidator },
    }
  })

  const $externalResults = ref({})
  const v$ = useVuelidate(rules, formState, { $externalResults })

  return { v$, $externalResults }
}

/**
 * Triggers validation of field values populated from URL query parameters
 *
 * @param v$
 * @param urlParamsDonorDetails
 */
export const triggerFieldValidationForUrlParams = (
  v$: any,
  urlParamsDonorDetails: UrlParamsDonorDetails<DonorDetails>
) => {
  Object.keys(pickBy(urlParamsDonorDetails, (v) => v !== '')).forEach(
    (field) => {
      if (field in v$.value) {
        v$.value[field].$touch()
      }
    }
  )
}
